import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Layout = ({ children }) => {
	return (
		<div className="h-screen w-full bg-green-50 overflow-auto">
			<div className="navbar sticky top-0 z-[100] bg-green-600 py-3 px-8 flex shadow-md">
				<Link to="/" className="flex">
					<span>
						<img src={logo} alt="" className="w-[30px] md:w-[40px] shadow-lg" />
					</span>
					<h1 className="text-2xl md:text-3xl font-medium text-white px-2">
						Expense Tracker
					</h1>
				</Link>
			</div>

			<div className="main mt-4 px-2 flex flex-col w-full justify-center items-center">
				<div className="w-full">{children}</div>
			</div>

			{/* <div className="footer mt-6 py-2 fixed bg-green-800 px-6 text-sm text-white w-full bottom-0">
				&copy;2022 : All Rights Receved By Sanjoy
			</div> */}
		</div>
	);
};

export default Layout;
